import React from "react";
import PropTypes from "prop-types";
import Head from "@al/next/head";
import BridgeV2 from "@akulaku/web-bridge";

export default function HeadTitle(props) {
  let title_text = "";
  if (process.browser) {
    title_text = props.title;
    if (title_text !== props.title) {
      BridgeV2.setNavTitle({ text: props.title });
      // bridge.run("setTitleText", { value: props.title });
      title_text = props.title;
    }
  }
  const { dkMap } = props;
  return (
    <Head>
      <title>{props.title}</title>
      {dkMap?.keywords && <meta name="keywords" content={dkMap.keywords} />}
      {dkMap?.description && <meta name="description" content={dkMap.description} />}
    </Head>
  );
}

HeadTitle.propTypes = {
  title: PropTypes.string.isRequired,
  dkMap: PropTypes.object | undefined,
};
